function initialState() {
  return {
    listProfessores: [],
    listDisciplinas: [],
  };
}

const mutations = {
  updateListProfessores(state, listProfessores) {
    state.listProfessores = listProfessores;
  },
  updateListDisciplinas(state, listDisciplinas) {
    state.listDisciplinas = listDisciplinas;
  }
};

const actions = {
  setListProfessores(state, listProfessores) {
    state.commit('updateListProfessores', listProfessores);
  },
  setListDisciplinas(state, listDisciplinas) {
    state.commit('updateListDisciplinas', listDisciplinas);
  },
};

const namespaced = true;

const graduacao = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default graduacao;


// WEBPACK FOOTER //
// ./src/store/graduacao.js